// extracted by mini-css-extract-plugin
export var darkMode = "_12-0";